import React from 'react';
import './Button.css';

const subscribeToHydration = () => () => undefined;
const interactiveSnapshot = () => true;
const serverSnapshot = () => false;

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'secondary',
      size = 'md',
      isLoading = false,
      children,
      className = '',
      disabled,
      ...props
    },
    ref,
  ) => {
    // Pre-rendered actions stay disabled until React has attached their handlers.
    const interactive = React.useSyncExternalStore(
      subscribeToHydration,
      interactiveSnapshot,
      serverSnapshot,
    );
    return (
      <button
        ref={ref}
        className={`sedlex-btn sedlex-btn--${variant} sedlex-btn--${size} ${isLoading ? 'is-loading' : ''} ${className}`}
        disabled={disabled || isLoading || !interactive}
        {...props}
      >
        {isLoading && <span className="sedlex-btn__spinner" aria-hidden="true" />}
        <span className="sedlex-btn__label">{children}</span>
      </button>
    );
  },
);
Button.displayName = 'Button';
